import React from 'react'
import PropTypes from 'prop-types'
import { Pipeline } from '@morningtrain/react-helpers'
import { TriggerPipelineOnFormSubmit, useModelKeyName, useOperation } from '@morningtrain/react-resources'
import { AddRouteToPayloadOnPipe, NavigateOnPipe, WhenRouteHasParameter } from '@morningtrain/react-navigation'

function RedirectToEditOnCreatePipeline (props) {
  let {
    routeName,
    modelKeyName,
    modelName,
    extraRouteParameters = {},
    children
  } = props

  const defaultModelKeyName = useModelKeyName()
  const operation = useOperation()

  if (!modelKeyName) {
    modelKeyName = defaultModelKeyName
  }

  if (!modelName && operation) {
    modelName = operation.modelName
  }

  const routeParameters = {
    [modelName]: 'payload:data.model.' + modelKeyName,
    ...extraRouteParameters
  }

  return (
    <WhenRouteHasParameter name={modelName} negate>
      <Pipeline>
        <TriggerPipelineOnFormSubmit />
        <AddRouteToPayloadOnPipe />
        {children}
        <NavigateOnPipe route={routeName} routeParameters={routeParameters} />
      </Pipeline>
    </WhenRouteHasParameter>
  )
}

RedirectToEditOnCreatePipeline.propTypes = {
  routeName: PropTypes.string.isRequired,
  modelKeyName: PropTypes.string,
  modelName: PropTypes.string,
  extraRouteParameters: PropTypes.object
}

export default RedirectToEditOnCreatePipeline
